import Konva from 'konva/konva'

const cornerRadius = 4
const pointerWidth = 10
const pointerHeight = 10
const padding = 3
const font = { family: 'Roboto', size: 14, color: 'rgba(0,0,0,0.87)' }
const color = '#eeeeee'
const opacity = 0.7
const border = { color: 'Black', width: 1 }

export default class Tooltip extends Konva.Label {
  constructor ({ x, y, width, text }) {
    super({ x, y })
    Object.assign(this, { width, text })

    this._render()
  }

  get pointerDirection () {
    const { width } = this
    return (this.x() > width / 2) ? 'right' : 'left'
  }

  _render () {
    this.destroyChildren()

    const { text, pointerDirection } = this

    this.add(new Konva.Tag({
      fill: color,
      pointerDirection,
      pointerWidth,
      pointerHeight,
      cornerRadius,
      opacity,
      strokeEnabled: true,
      stroke: border.color,
      strokeWidth: border.width
    }))

    this.add(new Konva.Text({
      text,
      fontFamily: font.family,
      fontSize: font.size,
      padding,
      fill: font.color
    }))
  }
}
